var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"trend-tag mr-2 mb-2",style:(_vm.styles),attrs:{"label":""}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }